import React from "react";
import { Link } from "react-router-dom";
import { useNavContext } from "../../context-api/nav-context";

const BoilerExtrasLeft = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section
      className="boiler-extras section-wrapper"
      onMouseOver={closeNavbarMenu}
    >
      <div className="boiler-extras-text">
        <h1 className="title">Choose Your Boiler</h1>
        <p className="subtitle boiler-margin">
          Answer some simple questions online and our quote engine will pick the
          most suitable boilers for your home. Our online quote gives you
          instant prices for the boilers we recommend
        </p>
        <Link to="/quotes" className="btn-hero btn-quote">
          Find A Boiler
        </Link>
      </div>
      <div className="boilers-extras-img">
        <div className="img-container">
          <img
            src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,w_580/v1643243826/AquaHeat/new%20images/how-long-do-boilers-last_lp5oag.webp"
            alt="boiler extras"
          />
        </div>
      </div>
    </section>
  );
};

export default BoilerExtrasLeft;
